import type { ReactNode } from 'react';
import { CameraOutlined, FileImageOutlined } from '@ant-design/icons';
import { Capacitor } from '@capacitor/core';
import { Dropdown, Modal, Upload } from 'antd';
import type { MenuProps } from 'antd';
import { useUploadPhoto } from 'common/hooks/use-upload-photo/use-upload-photo';
import './upload-photo.scss';

interface IUploadPhotoProps {
  hook: ReturnType<typeof useUploadPhoto>;
  uploadText: ReactNode;
}

export const UploadPhoto = ({ hook, uploadText }: IUploadPhotoProps) => {
  const isNative = Capacitor.isNativePlatform();
  const { Dragger } = Upload;

  const items: MenuProps['items'] = [
    {
      key: 'camera',
      label: 'Take a Photo',
      icon: <CameraOutlined />,
      onClick: () => void hook.takePicture(),
    },
    {
      key: 'gallery',
      label: 'Photo Library',
      icon: <FileImageOutlined />,
      onClick: () => void hook.selectFromGallery(),
    },
  ];

  return (
    <div className="upload-photo-wrapper">
      <Dragger {...hook.uploadProps} openFileDialogOnClick={!isNative}>
        {isNative ? (
          <Dropdown menu={{ items }} trigger={['click']}>
            <div>{uploadText}</div>
          </Dropdown>
        ) : (
          uploadText
        )}
      </Dragger>

      <Modal open={hook.previewOpen} footer={null} onCancel={() => hook.setPreviewOpen(false)}>
        <img alt="Photo preview" src={hook.previewImage} style={{ width: '100%' }} />
      </Modal>
    </div>
  );
};
